import { Menu } from 'antd';
import { useCallback } from 'react';

import { ListMeta } from '../../../components/GdList';
import Text from '../../../components/Text';
import { GlossaryWordListItem } from '../stores/glossaryStore';

type GlossaryMetaOutput = {
  columnsMeta: ListMeta;
};

type GlossaryMetaInput = {
  onEditClicked: (word: GlossaryWordListItem) => void;
  onDeleteClicked: (word: GlossaryWordListItem) => void;
};

export const useGlossaryMeta = ({
  onEditClicked,
  onDeleteClicked,
}: GlossaryMetaInput): GlossaryMetaOutput => {
  const onEditMenuClicked = useCallback(
    (word: any) => () => {
      onEditClicked(word);
    },
    [onEditClicked]
  );

  const onDeleteMenuClicked = useCallback(
    (word: any) => () => {
      onDeleteClicked(word);
    },
    [onDeleteClicked]
  );

  const columnsMeta: ListMeta = {
    word: {
      span: 4,
      overrideStyle: true,
      className: 'gd-list-title',
    },
    text: {
      span: 7,
      render: (item) => (
        <Text fontSize={12} fontFamily="montserrat-regular">
          {(item.text as string) || '—'}
        </Text>
      ),
    },
    labelLink: {
      span: 5,
      render: (item) => (
        <Text fontSize={12} fontFamily="montserrat-regular">
          {(item.labelLink as string) || '—'}
        </Text>
      ),
    },
    link: {
      span: 5,
      render: (item) => (
        <Text fontSize={12} fontFamily="montserrat-regular">
          {(item.link as string) || '—'}
        </Text>
      ),
    },
    menu: {
      span: 3,
      render: (item) => (
        <Menu>
          <Menu.Item key={1} onClick={onEditMenuClicked(item)}>
            Edit
          </Menu.Item>
          <Menu.Item key={2} onClick={onDeleteMenuClicked(item)}>
            Delete
          </Menu.Item>
        </Menu>
      ),
    },
  };

  return { columnsMeta };
};
